import { groupBy, uniq } from "lodash";
import { Item__Resumo, ResumoMonitoramento } from "../../../../../services/monitoramento/resumo/get";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { removerEspacos } from "../../../../../utils";

export function ProcessarResumo(dadosResumoMonitoramento: ResumoMonitoramento['itens'], filtrar_talhoes: any[], data_monitoramento: string, agrupar_resumo: boolean) {

    let filtrar_por_talhao = filtrar_talhoes?.length === 0 ? dadosResumoMonitoramento : dadosResumoMonitoramento.filter(item => filtrar_talhoes.includes(item.cod_talhao));
    let filtrar_por_data_monitoramento = filtrar_por_talhao.filter(item => item.data_inicio === data_monitoramento);

    // if (agrupar_resumo) {
    //     /**Agrupando por propriedade apenas para manter dados em um único array
    //      * pois como será resumido agrupado, não pode seperar por talhão
    //      */
    //     let agrupar_por_propriedade = groupBy(filtrar_por_data_monitoramento, 'cod_propriedade');

    //     let listagem_agrupada = Object.entries(agrupar_por_propriedade).map(([cod_propriedade, dados])=> {
    //         return {
    //             cod_talhao: Number(cod_propriedade), 
    //             nome_talhao: uniq(dados.map((item=> item.talhao+', '))),
    //             dados_resumo: dados
    //         }
    //     });

    //     return listagem_agrupada;
    // }
    
    let agrupar_por_talhao = groupBy(filtrar_por_data_monitoramento, 'cod_talhao');

    let listagem_agrupada = Object.entries(agrupar_por_talhao).map(([cod_talhao, dados])=> {
        return {
            cod_talhao: Number(cod_talhao), 
            nome_talhao: dados?.[0]?.talhao,
            dados_resumo: dados
        }
    });

    return listagem_agrupada;
}

export function filtrarPragas(lista_pragas:Item__Resumo[], pragas_selecionadas_resumo: CheckboxValueType[], is_agrupar_resumo: boolean): any {

    let filtrar_pragas = pragas_selecionadas_resumo.map((praga_e_cods)=>{
        let split = `${String(praga_e_cods).split(',')[1]}_${String(praga_e_cods).split(',')[2]}`;
        return removerEspacos(split)
    })

    let listagem_pragas_com_ref = lista_pragas.map((item)=> {
        return {
            ...item,
            cod_especie_e_cod_variacao: `${item.cod_especie}_${item.cod_variacao_especie}`
        }
    });    
    
    if ((lista_pragas??[]).length > 0 && is_agrupar_resumo) {

        let agrupar = groupBy(lista_pragas, 'especie');

        let montar_lista_agrupada = (Object?.entries(agrupar) ?? []).map(([nome_especie, dados_agrupados])=> {
            return {
                especie: nome_especie,
                variacao: undefined,
                qtd_variacoes: dados_agrupados.length,
                pontos: dados_agrupados.reduce((acumulador: number, item: any)=> acumulador + item.pontos, 0),
                tipo_metrica_nome: dados_agrupados?.[0]?.tipo_metrica_nome,
                minimo: Math.min(...dados_agrupados.map(item => Number(item.minimo))),
                media: (dados_agrupados.reduce((acumulador: number, item: any)=> acumulador + Number(item.media), 0)) / dados_agrupados.length,
                maximo: Math.max(...dados_agrupados.map(item => Number(item.maximo))),
                nivel_controle: dados_agrupados.reduce((acumulador: number, item: any)=> acumulador + Number(item.nivel_controle), 0),
                inverter_escala: dados_agrupados.reduce((acumulador: boolean, item: any)=> acumulador + item.inverter_escala, false),
                lista_variacoes: dados_agrupados,
                cod_especie_e_cod_variacao: `${dados_agrupados?.[0].cod_especie}_${dados_agrupados?.[0].cod_variacao_especie}`
            }
        })

        let filtrado = montar_lista_agrupada.filter((item=> filtrar_pragas.includes(item.cod_especie_e_cod_variacao)));
        
        return pragas_selecionadas_resumo?.length === 0 ? montar_lista_agrupada :  filtrado;
    }


    let filtrado = listagem_pragas_com_ref.filter((item=> filtrar_pragas.includes(item.cod_especie_e_cod_variacao)));
        
    return pragas_selecionadas_resumo?.length === 0 ? listagem_pragas_com_ref :  filtrado;
};

export function obterVariacaoes(lista_pragas:Item__Resumo[], nome_praga: string) {
    let filtrar_praga = lista_pragas.filter(item=> item.especie === nome_praga);
    let apenas_variacoes = filtrar_praga.map(item=> item.variacao);

    let listagem_variacoes = (uniq(apenas_variacoes)).map((nome_variacao, index)=> {
        if (nome_variacao === null) {
            return ''
        }
        return index < (uniq(apenas_variacoes).length - 1) ? nome_variacao+', ' : nome_variacao
    });

    return listagem_variacoes ??  ''
}

export function descricaoEscala(valor: number): 'Ausente' | 'Baixo' | 'Médio' | 'Alto' | 'Muito Alto' {
    if (valor===0) {
        return 'Ausente'
    }
    if (valor > 0 && valor <= 1.5) {
        return 'Baixo'
    }
    if (valor > 1.5 && valor <= 2.5) {
        return 'Médio'
    }
    if (valor > 2.5 && valor <= 3.5) {
        return 'Alto'
    }
    if (valor > 3.5) {
        return 'Muito Alto'
    }
    else {
        '@Ausente'
    }
}